import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import {
  OneStarIcon,
  ThreeStarIcon,
  TwoStarIcon,
} from '../../../../layouts/dashboard/nav/IconButton';
import { InspectionScoreList } from '../../../../utils/enum';

export const statusTypes = _.keyBy(
  [
    {
      id: InspectionScoreList.A,
      label: 'A',
      icon: <ThreeStarIcon />,
    },
    {
      id: InspectionScoreList.B,
      label: 'B',
      icon: <TwoStarIcon />,
    },
    {
      id: InspectionScoreList.C,
      label: 'C',
      icon: <OneStarIcon />,
    },
  ],
  'id',
);
export function RatingStatusChips({ status }: any) {
  const label = statusTypes[status];

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        color: '#5546A9',
        alignItems: 'center',
        justifyContent: 'center',
        pb: 0.5,
      }}
    >
      <Typography sx={{ pt: 0.5, fontWeight: 700, fontSize: '12px' }}>
        {_.get(label, 'label', '-')}
      </Typography>
      {label?.icon}
    </Stack>
  );
}
